
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, CheckCircle } from 'lucide-react';

const UserManagementTools = () => {
  return (
    <Card className="bg-gray-800 border-gray-700">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-white">
          <Users className="h-5 w-5 text-sports-green" />
          User Management Tools
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>User Registration</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Profile Management</span>
          </div>
          <div className="flex items-center gap-2 text-gray-300">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span>Role Permissions</span>
          </div>
          <p className="text-sm text-gray-400 mt-4">
            User management systems are operational.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default UserManagementTools;
